import { CommitmentStatus } from "@/services/backend/relationships/types/relationship";
import { CircleAlert, CircleCheck, CircleX } from "lucide-react";
import { cn } from "@/shared/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/components/ui/tooltip";
import t from "@/lang/lang";

export function CommitmentStatusIcon({
  status,
  className,
}: {
  status: CommitmentStatus;
  className?: string;
}) {
  const defaultClassName = "inline size-5";

  return (
    <Tooltip>
      <TooltipTrigger>
        {status === CommitmentStatus.NotFulfilled && (
          <CircleAlert
            className={cn(defaultClassName, "text-destructive", className)}
          />
        )}
        {status === CommitmentStatus.PartiallyFulfilled && (
          <CircleCheck
            className={cn(defaultClassName, "text-yellow-500", className)}
          />
        )}
        {status === CommitmentStatus.Fulfilled && (
          <CircleCheck
            className={cn(defaultClassName, "text-green-700", className)}
          />
        )}
        {status === CommitmentStatus.Skipped && (
          <CircleX className={cn(defaultClassName, className)} />
        )}
      </TooltipTrigger>
      <TooltipContent>
        <p>{t(status)}</p>
      </TooltipContent>
    </Tooltip>
  );
}
